module.exports = __webpack_public_path__ + "static/media/VIP_Entry_Locked@3x.626d4fb6.png";